<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate color="primary" />
    </v-overlay>
    <v-container v-if="!loading && client">
      <v-row>
        <v-col cols="3">
          <div class="d-flex flex-row text--primary justify-center align-center">
            <label class="text--primary pr-2">Client:</label>
            <label v-if="!loading" class="text--primary">{{ client.name }}</label>
            <v-skeleton-loader v-if="loading" type="table-cell" />
          </div>
        </v-col>
        <v-col cols="3">
          <v-text-field v-model="startDate" type="date" label="Choose a starting date" outlined dense clearable />
        </v-col>
        <v-col cols="3">
          <v-text-field v-model="endDate" type="date" label="Choose an end date" outlined dense clearable />
        </v-col>
        <v-col class="text-right" cols="2">
          <v-btn color="primary" :loading="overviewLoading" @click="updateDashboardData"> Update </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <customer-overview :satisfaction-level="client.satisfactionLevel" :client-id="client.clientId" />
        <service-status />
        <monthly-performance :loading="loading" />
      </v-row>
      <v-row>
        <whizeo-strategy-report :client-id="client.clientId" />
        <bot-performance />
        <bot-results />
      </v-row>
      <v-row class="ml-12 mr-12">
        <agent-activity />
        <agent-performance :loading="loading" />
      </v-row>
      <v-row class="d-flex justify-center">
        <csm-notes :client-id="client.clientId" class="csm-notes" />
      </v-row>
    </v-container>
    <v-alert v-if="!loading && !client" border="bottom" colored-border type="warning" elevation="2">
      {{ noClient }}
    </v-alert>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import CustomerOverview from '../components/HealthScore/CustomerOverview.vue';
import ServiceStatus from '../components/HealthScore/ServiceStatus.vue';
import MonthlyPerformance from '../components/HealthScore/MonthlyPerformance.vue';
import BotPerformance from '../components/HealthScore/BotPerformance.vue';
import BotResults from '../components/HealthScore/BotResults.vue';
import AgentActivity from '../components/HealthScore/AgentActivity.vue';
import AgentPerformance from '../components/HealthScore/AgentPerformance.vue';
import i18n from '../setup/locale/en';
import { LoadingState } from '@/store/constants';
import moment from 'moment';
import CsmNotes from '@/components/HealthScore/CsmNotes/CsmNotes.vue';
import WhizeoStrategyReport from '@/components/HealthScore/WhizeoStrategyReport.vue';

export default {
  components: {
    WhizeoStrategyReport,
    CsmNotes,
    AgentPerformance,
    AgentActivity,
    BotResults,
    BotPerformance,
    CustomerOverview,
    ServiceStatus,
    MonthlyPerformance,
  },
  props: {
    clientId: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    menu: false,
    loading: true,
    startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    noClient: i18n.clients.healthScore.errors.noClient,
    currentNote: null,
  }),
  methods: {
    ...mapActions('whizeosupportToolsStore', ['SHOW_SNACKBAR']),
    ...mapActions('clientStore', ['fetchClients']),
    ...mapActions('healthScoreStore', [
      'fetchOverview',
      'fetchLeads',
      'fetchMonthlyPerformance',
      'fetchAgentActivity',
      'fetchCsmNotes',
      'fetchChatSystemScore',
      'fetchWhizeoHealthScore',
    ]),
    async updateDashboardData() {
      this.fetchOverview(this.dashboardParams);
      this.fetchLeads(this.dashboardParams);
      this.fetchAgentActivity(this.dashboardParams);
      this.fetchCsmNotes(this.dashboardParams);
    },
    async loadDashboardData() {
      this.updateDashboardData();
      this.fetchMonthlyPerformance(this.dashboardParams);
      this.fetchChatSystemScore(this.dashboardParams);
      this.fetchWhizeoHealthScore(this.dashboardParams);
    },
  },
  async mounted() {
    if (this.loadingState === LoadingState.EMPTY) {
      this.loading = true;
      await this.fetchClients();
    }
    this.loading = false;
    await this.loadDashboardData();
  },
  computed: {
    ...mapGetters('clientStore', ['getClientByClientId']),
    ...mapState('clientStore', ['loadingState']),
    ...mapState('healthScoreStore', ['chatOverview', 'agentActivity']),
    dashboardParams() {
      return {
        clientId: this.intClientId,
        startDate: this.startDate,
        endDate: this.endDate,
      };
    },
    overviewLoading() {
      return this.chatOverview.state === LoadingState.LOADING;
    },
    intClientId() {
      return Number.parseInt(this.clientId, 10);
    },
    client() {
      return this.getClientByClientId(this.intClientId);
    },
  },
};
</script>
<style>
.csm-notes {
  width: 50%;
}
</style>
